import { Methods, RestClient } from 'o2o_layout/lib/common/rest';

import { BIGDATA_CONSTANT } from '../../../../../../../common/constant';

const GetOrg2FAPolicy = () => {
  let url = BIGDATA_CONSTANT.url.api + `mngmnt-client/orgs/config/2fa-policy`;

  let restClient = new RestClient(Methods.GET, url);

  return new Promise((resolve, reject) => {
    restClient.execute({}, {}).then(
      (response: any) => {
        const user: any = response.data;
        resolve(user);
      },
      (error) => {
        reject(error);
      }
    );
  });
};

export default GetOrg2FAPolicy;
